import isNil from 'lodash/isNil'
import { GeckoMeasurement } from 'types'

export type Coordinate = {
  x: GeckoMeasurement
  y: GeckoMeasurement
}
export type EditableCoordinate = {
  stableKey: string
  x: GeckoMeasurement | undefined
  y: GeckoMeasurement | undefined
}

export function isFullyDefinedCoordinateArray(
  inputCoords: ReadonlyArray<Omit<EditableCoordinate, 'stableKey'>>
): inputCoords is ReadonlyArray<Coordinate> {
  return inputCoords.every(isFullyDefinedCoordinate)
}

export function isFullyDefinedCoordinate(
  inputCoord: Omit<EditableCoordinate, 'stableKey'>
): inputCoord is Coordinate {
  return (
    !isNil(inputCoord.x) &&
    !isNil(inputCoord.y) &&
    !isNaN(inputCoord.x.num) &&
    !isNaN(inputCoord.y.num)
  )
}

export function serializeCoordinates(
  coords: ReadonlyArray<Coordinate>
): string {
  return coords.map((c) => `[${c.x.num}, ${c.y.num}]`).join(', ')
}
